import { schedulePaymentsConstants } from "../_redux/_constants";

const getScheduleFrequencyLabel = (frequency) => {
  let frequencyArray =
    schedulePaymentsConstants.recurringFrequencyOptions.filter(
      (option) => option.value === frequency,
    );

  return frequencyArray?.length === 1 ? frequencyArray[0]?.label : "";
};

export { getScheduleFrequencyLabel };
